import React from 'react';
import { Loader2 } from 'lucide-react';
import { INDUSTRIES } from './setupConstants';

export const StepDomainIndustry = ({
  form, setForm,
  yabbitDomains, loadYabbitDomains, loadingDomains,
  onSelectDomain,
  loadExtensions,
}) => (
  <div className="space-y-5">
    <div>
      <div className="flex items-center justify-between mb-2">
        <label className="text-xs text-white/50">Yabbit UCaaS Domain *</label>
        <button
          onClick={loadYabbitDomains}
          disabled={loadingDomains}
          className="text-xs text-teal-400 hover:text-teal-300 flex items-center gap-1"
          data-testid="fetch-domains-btn"
        >
          {loadingDomains ? <Loader2 className="w-3 h-3 animate-spin" /> : null}
          Fetch Domains
        </button>
      </div>
      {yabbitDomains.length > 0 ? (
        <div className="space-y-2 max-h-48 overflow-y-auto">
          {yabbitDomains.map(d => (
            <button
              key={d.domain}
              onClick={() => onSelectDomain(d.domain)}
              className={`w-full text-left px-3 py-2.5 rounded-lg border text-sm transition-colors ${
                form.yabbit_domain === d.domain
                  ? 'border-teal-500 bg-teal-500/10 text-teal-300'
                  : 'border-white/10 bg-white/5 text-white hover:border-white/20'
              }`}
            >
              {d.domain}
              {d.description && <span className="text-white/30 ml-2 text-xs">{d.description}</span>}
            </button>
          ))}
        </div>
      ) : (
        <div>
          <input
            type="text"
            value={form.yabbit_domain}
            onChange={e => setForm(f => ({ ...f, yabbit_domain: e.target.value }))}
            onBlur={() => form.yabbit_domain && loadExtensions(form.yabbit_domain)}
            placeholder="e.g. ipvsyabbit"
            className="w-full bg-white/5 border border-white/10 rounded-lg px-3 py-2.5 text-white text-sm placeholder-white/20 focus:outline-none focus:border-teal-500/50"
            data-testid="domain-name-input"
          />
          <p className="text-white/30 text-xs mt-1">Or click "Fetch Domains" to select from Yabbit</p>
        </div>
      )}
    </div>

    <div>
      <label className="block text-xs text-white/50 mb-1">Custom Reseller API Key (optional)</label>
      <input
        type="text"
        value={form.reseller_key}
        onChange={e => setForm(f => ({ ...f, reseller_key: e.target.value }))}
        placeholder="nss_... (leave blank to use default)"
        className="w-full bg-white/5 border border-white/10 rounded-lg px-3 py-2.5 text-white text-sm placeholder-white/20 focus:outline-none focus:border-teal-500/50"
        data-testid="reseller-key-input"
      />
    </div>

    <div>
      <label className="block text-xs text-white/50 mb-2">Industry Vertical *</label>
      <div className="grid grid-cols-2 gap-2 max-h-64 overflow-y-auto">
        {INDUSTRIES.map(ind => (
          <button
            key={ind.value}
            onClick={() => setForm(f => ({ ...f, industry: ind.value }))}
            className={`text-left px-3 py-2 rounded-lg text-sm transition-colors border ${
              form.industry === ind.value
                ? 'border-teal-500 bg-teal-500/10 text-teal-300'
                : 'border-white/10 bg-white/5 text-white/60 hover:text-white'
            }`}
            data-testid={`industry-${ind.value}`}
          >
            {ind.label}
          </button>
        ))}
      </div>
    </div>
  </div>
);
